
import React from 'react';
import { useApp } from '../../context/AppContext';
import { Mail, ArrowRight } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

const VerifyEmail: React.FC = () => {
  const { verifyEmail, currentUser } = useApp();
  const { toast } = useToast();

  const handleVerify = () => {
    verifyEmail();
    toast({
      title: "Email verified",
      description: "Your account is now active",
    });
  };

  return (
    <div className="flex flex-col h-full items-center justify-center px-6">
      <div className="bg-neobank-lightAccent p-6 rounded-full mb-8">
        <Mail className="w-16 h-16 text-neobank-primary" />
      </div>
      
      <h1 className="text-2xl font-bold mb-4 text-center">Check Your Email</h1>
      
      <p className="text-center text-gray-600 mb-8">
        We've sent a verification link to <strong>{currentUser?.email}</strong>. Click the link to verify your account.
      </p>
      
      {/* For the purpose of this demo, we'll simulate email verification */}
      <p className="text-center text-sm text-gray-500 mb-8">
        For demo purposes, click the button below to simulate email verification:
      </p>
      
      <button onClick={handleVerify} className="btn-primary flex items-center justify-center">
        Verify Email <ArrowRight className="ml-2 w-4 h-4" />
      </button>
    </div>
  );
};

export default VerifyEmail;
